define(['query-string', 'history', 'app/modules/infiniteScroll'], (queryString, history, InfiniteScroll) => {
  let browserHistory = history.createBrowserHistory();
  let VISIBLE_CLASS = 'loaded';
  let HIDDEN_CLASS = 'hidden';
  let SEARCH_PARAM_NAME = 'search_text';

  let FilteringList = function(options) {
    this.onSuccessCb = options.onSuccess;
    this.withoutHistoryUpdating = options.withoutHistoryUpdating;
    this.$filter = $('.js-filter');
    this.$list = $('.js-filtering-list');
    this.$search = $('.js-filter-search');
    this.$listSpinner = $('.js-list-spinner');
    this.$searchClearIcon = $('.js-search-icon');
    this.$loadMore = $('.js-load-more');
    this.$clearButtonWrapper = $('.js-clear-filter');
    this.$clearButton = $('.js-clear-filter-button');
    this.url = this.$filter.data('url');

    this.load = this.load.bind(this);
    this.onLoadMore = this.onLoadMore.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.setSearch = this.setSearch.bind(this);

    this.bindCheckboxes();
    this.bindSearch();
    this.bindClearButton();
    this.load(this.url);
    this.initInfiniteScroll();

    if (!this.withoutHistoryUpdating) {
      this.updateFilter = this.updateFilter.bind(this);
      browserHistory.listen(this.updateFilter);
    }
  };

  FilteringList.prototype.initInfiniteScroll = function() {
    if (this.$list.length) {
      new InfiniteScroll({
        $el: this.$list,
        onLoadSuccess: this.onLoadMore
      });
    }
  };

  FilteringList.prototype.bindCheckboxes = function() {
    let self = this;

    this.$filter
      .find('input.js-filter-input')
      .iCheck({ handle: 'checkbox' })
      .on('ifChecked', function() {
        $(this)
          .parents('.job-filter-item')
          .addClass('active');
      })
      .on('ifUnchecked', function() {
        $(this)
          .parents('.job-filter-item')
          .removeClass('active');
      })
      .on('ifClicked', () => {
        self.filteringOnTimeout();
      })
      .on('ifChanged', () => {
        if (self.$filter.find('input.js-filter-input:checked').length <= 0) {
          self.$clearButtonWrapper.addClass(HIDDEN_CLASS);
        } else {
          self.$clearButtonWrapper.removeClass(HIDDEN_CLASS);
        }
      });
  };

  FilteringList.prototype.filteringOnTimeout = function(timeout) {
    timeout = timeout || 1000;
    clearTimeout(window.filter_timeout);
    window.filter_timeout = setTimeout(() => {
      this.getFilters();
    }, timeout);
  };

  FilteringList.prototype.bindClearButton = function() {
    let self = this;

    this.$clearButton.on('click', () => {
      var params = {};
      var searchValue = self.$search.val();
      var openedPanel = self.$filter.find('.collapse.in[aria-expanded="true"]');

      if (searchValue && searchValue.length > 0) {
        params[SEARCH_PARAM_NAME] = searchValue;
      }

      browserHistory.push(browserHistory.location.pathname);
      self.setFilters({});
      self.sendRequest(self.url, params);

      openedPanel.collapse('hide');
      openedPanel.siblings('.ca-override__color').removeClass('ca-override__color');
    });
  };

  FilteringList.prototype.bindSearch = function() {
    let self = this;

    this.$search.keyup(function() {
      let value = $(this).val();
      if (value.length > 0) {
        self.$searchClearIcon.removeClass(HIDDEN_CLASS);
      } else {
        self.$searchClearIcon.addClass(HIDDEN_CLASS);
      }
      self.filteringOnTimeout(500);
    });

    this.$searchClearIcon.on('click', function() {
      self.$search.val('');
      $(this).addClass(HIDDEN_CLASS);
      self.filteringOnTimeout();
    });
  };

  FilteringList.prototype.getFilters = function() {
    let filterParams = {};

    this.$filter.find('[data-filter]').each(function() {
      let $this = $(this);
      let filterName = $this.data('filter');
      let filterTitle = $this.find('a.panel-heading');
      let $inputs = $this.find('.js-filter-input:checked');

      if ($inputs.length) {
        filterParams[filterName] = filterParams[filterName] || [];

        $inputs.each(function() {
          filterParams[filterName].push($(this).val());
        });
      }

      if ($inputs.length) {
        filterTitle.addClass('ca-override__color');
      } else {
        filterTitle.removeClass('ca-override__color');
      }
    });

    let searchTextValue = this.$search.val();
    if (searchTextValue && searchTextValue.length >= 2) {
      filterParams[SEARCH_PARAM_NAME] = searchTextValue;
    }

    this.load(this.url, filterParams);
  };

  FilteringList.prototype.setFilters = function(params) {
    if (!params) return;

    let self = this;

    this.$filter.find('.js-filter-input:checked').iCheck('uncheck');

    Object.keys(params).forEach(paramName => {
      if (paramName === SEARCH_PARAM_NAME) {
        return self.setSearch(params[SEARCH_PARAM_NAME]);
      }

      var $filter = self.$filter.find('[data-filter=' + paramName + ']');
      var id = $filter.find('[role="tabpanel"]').attr('id');
      var $panel = $filter.find('#' + id);

      if (params[paramName] && params[paramName].map) {
        var inputs = params[paramName]
          .map(function(value) {
            return '.js-filter-input[value="' + value + '"]';
          })
          .join(',');

        $filter.find(inputs).iCheck('check');
        $panel.collapse();
      }
    });
  };

  FilteringList.prototype.setSearch = function(value) {
    if (value !== this.$search.val()) {
      this.$search.val(value);
    }

    if (value.length) {
      this.$searchClearIcon.removeClass(HIDDEN_CLASS);
    }
  };

  FilteringList.prototype.onLoadMore = function(results) {
    this.onSuccessCb(results);
    this.$loadMore.html(results.load_more);
  };

  FilteringList.prototype.updateFilter = function(location, action) {
    let params = queryString.parse(location.search, {
      arrayFormat: 'bracket'
    });

    if (action === 'POP') {
      this.load(this.url, params);
    }
  };

  FilteringList.prototype.load = function(url, params) {
    if (!this.withoutHistoryUpdating) {
      let queryParams = queryString.stringify(params, {
        arrayFormat: 'bracket'
      });
      let search = browserHistory.location.search.replace('?', '');

      if (params && search !== queryParams) {
        browserHistory.push(`${browserHistory.location.pathname}?${queryParams}`);
      }

      if (!params && search !== queryParams) {
        let query = queryString.parse(search, {
          arrayFormat: 'bracket'
        });
        params = query;
      }

      this.setFilters(params);
    }

    this.sendRequest(url, params);
  };

  FilteringList.prototype.sendRequest = function(url, params) {
    this.$listSpinner.removeClass(VISIBLE_CLASS);

    $.ajax({
      type: 'GET',
      url,
      data: { filter_params: params || {} },
      success: this.onSuccess
    });
  };

  FilteringList.prototype.onSuccess = function(results) {
    this.$listSpinner.addClass(VISIBLE_CLASS);
    this.$loadMore.html(results.load_more);
    this.onSuccessCb(results);
  };

  return FilteringList;
});
